import axios from "axios";
import { useEffect, useState, useContext } from "react";

// internal import
import { allContext } from "../context/AllContext";

const useAsync = (asyncFunction) => {
    const [data, setData] = useState([] || {});
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(true);
    const [tableLoading, setTableLoading] = useState(true);

    const { dataUpdate, reportSearch } = useContext(allContext);

    useEffect(() => {
        setTableLoading(true);
        let unmounted = false;
        let source = axios.CancelToken.source();
        (async () => {
            try {
                const res = await asyncFunction({ cancelToken: source.token });
                if (!unmounted) {
                    setData(res);
                    setError("");
                    setLoading(false);
                    setTableLoading(false);
                }
            } catch (err) {
                if (!unmounted) {
                    setError(err.message);
                    if (axios.isCancel(err)) {
                        setError(err.message);
                        setLoading(false);
                        setTableLoading(false);
                        setData([]);
                    } else {
                        setError(err.message);
                        setLoading(false);
                        setTableLoading(false);
                        setData([]);
                    }
                }
            }
        })();

        // setIsUpdate(false);

        return () => {
            unmounted = true;
            source.cancel("Cancelled in cleanup");
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        dataUpdate,
        //  fromTime,
        // toTime,
        // employeeID,
        // type,
         reportSearch]);

    return {
        data,
        error,
        loading,
        tableLoading
    };
};

export default useAsync;